import { defineComponent as _defineComponent } from 'vue'
import EventBus from '@/util/bus'
import { EventBusKey } from '@/util/bus'
import { computed, onMounted, onUnmounted, ref } from 'vue'

import mMenu from './m-menu.vue'

interface MenuDataType {
  key: string
  label: any
  type: string
  icon?: string
  children?: MenuDataType[]
  parentId: number
  id: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    position: { default: () => {
      return {
        x: 0,
        y: 0,
      }
    } },
    data: { default: () => [] },
    zIndex: { default: 100 },
    positionStyle: { default: 'fixed' },
    isUseSaw: { type: Boolean, default: false }
  },
  emits: ["selectMenuItem"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'selectMenuItem', item: MenuDataType): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { position: {
      x: number
      y: number
    }, data: Array<MenuDataType>, zIndex: number, positionStyle: 'absolute' | 'fixed', isUseSaw: boolean }





const config = computed(() => {
  return {
    position: props.position,
    data: props.data,
    zIndex: props.zIndex,
    positionStyle: props.positionStyle,
    isUseSaw: props.isUseSaw,
  }
})

const mMenuRef = ref<InstanceType<typeof mMenu> | null>(null)

const openMenu = () => {
  mMenuRef.value?.openMenu()
}

const closeMenu = (e: WheelEvent | KeyboardEvent | FocusEvent) => {
  if (e instanceof WheelEvent && e.ctrlKey) {
    e.preventDefault()
  }
  mMenuRef.value?.closeMenu()
}

expose({
  openMenu,
  closeMenu,
})

onMounted(() => {
  EventBus.$on(EventBusKey.SELECT_MENU_ITEM, (item: MenuDataType) => {
    emit('selectMenuItem', item)
  })
  // 这里为什么要在捕获阶段执行了，因为我也不知道项目中什么地方做过处理，全局的点击事件都不会再冒泡阶段执行，所以这里只能放在捕获阶段。
  window.addEventListener('click', closeMenu, { capture: true })
  window.addEventListener('dblclick', closeMenu)
  window.addEventListener('keydown', closeMenu)
  window.addEventListener('keyup', closeMenu)
  window.addEventListener('blur', closeMenu)
  window.addEventListener('wheel', closeMenu, { passive: false })
})

onUnmounted(() => {
  window.removeEventListener('click', closeMenu)
  window.removeEventListener('dblclick', closeMenu)
  window.removeEventListener('keydown', closeMenu)
  window.removeEventListener('keyup', closeMenu)
  window.removeEventListener('blur', closeMenu)
  window.removeEventListener('wheel', closeMenu)
})

return { __sfc: true,props, emit, config, mMenuRef, openMenu, closeMenu, mMenu }
}

})